module.exports = __webpack_public_path__ + "img/1506021016.af0ef40a.jpg";